<form [formGroup]="form" class="border-bottom">
  @if (isLoading()) {
  <div class="row row-gap-2 g-6 mb-8 px-3 mt-1">
    <div class="skeleton col-12 col-lg-12 mt-8 min-h-40px"></div>
    <div class="skeleton col-12 mt-2 min-h-100px"></div>
    <div class="d-grid grid-3 gap-4 p-0 mt-2">
      <div class="skeleton min-h-40px"></div>
      <div class="skeleton min-h-40px"></div>
      <div class="skeleton min-h-40px"></div>
    </div>
    <div class="skeleton col-12 mt-2 min-h-40px"></div>
  </div>
  }@else{
  <app-form [form]="form" [getterError]="error"></app-form>
  <!-- <div class="row g-6">
    <div class="col-12 col-lg-12 mt-8">
      <app-input label="ชื่อที่อยู่" name="name" formControlName="name" placeholder="บ้าน/โรงเรียน"
        [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error?.name"></app-input>
    </div>
    <div class="col-12 mt-2">
      <app-textarea label="รายละเอียดที่อยู่" name="address" formControlName="address"
        placeholder="บ้านเลขที่ หมู่ หมู่บ้าน ถนน" [labelMode]="LabelMode.DEFAULT" minHeightClass="min-h-100px"
        [required]="true" [error]="error?.address"></app-textarea>
    </div>
    <div class="col-md-4 mt-2">
      <app-select label="จังหวัด" placeholder="จังหวัด" name="province_id" formControlName="province_id"
        bindLabel="name_th" autocomplete="shipping locality" [labelMode]="LabelMode.DEFAULT"
        [error]="error?.province_id" [required]="true" url="/provinces"></app-select>
    </div>
    <div class="col-md-4 mt-2">
      <app-select label="อำเภอ/เขต" placeholder="อำเภอ/เขต" name="district_id" formControlName="district_id"
        bindLabel="name_th" autocomplete="shipping region" [labelMode]="LabelMode.DEFAULT" [error]="error?.district_id"
        [required]="true" [isDisabled]="!form.value.province_id" url="/districts"
        [query]="{ province_id: form.value.province_id }"></app-select>
    </div>
    <div class="col-md-4 mt-2">
      <app-select label="ตำบล/แขวง" placeholder="ตำบล/แขวง" name="sub_district_id" formControlName="sub_district_id"
        bindLabel="name_th" autocomplete="shipping sub-district" [labelMode]="LabelMode.DEFAULT"
        [error]="error?.sub_district_id" [isDisabled]="!form.value.district_id" [required]="true" url="/sub_districts"
        [query]="{ district_id: form.value.district_id }"></app-select>
    </div>
    <div class="col-12 mt-2">
      <app-input label="รหัสไปรษณีย์" name="post_code" formControlName="post_code" autocomplete="shipping postal-code"
        placeholder="รหัสไปรษณีย์" [labelMode]="LabelMode.DEFAULT" [required]="true" mask="00000"
        [error]="error?.post_code" [isDisabled]="true"></app-input>
    </div>
  </div> -->
  <div class="d-flex justify-content-end align-items-center gap-4 mt-6 mb-8">
    <button class="btn btn-sm btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800"
      (click)="onCloseForm()">
      ยกเลิก
    </button>

    <button class="btn btn-sm btn-primary" (click)="submit()">บันทึก</button>
  </div>
  }
</form>